import React from 'react';
import { connect } from 'react-redux';
import MarketMenuContent from '../../../../shared/MarketMenuContent';

const NestedMarketMenu: React.FC = () => {
  return <MarketMenuContent isOpen />;
};

export default connect()(NestedMarketMenu);
